import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    promotionId: '',
    defaultBrand: {},
    promotionDataList: [],
    promotionDataListById: {},
    isEditFormVisible: true,
    onEdit: true,
    createPromotionDetails: {},
    startDate: '',
    endDate: '',
    filterModel: '',
    styleCodeType: {}
};

const promotionSlice = createSlice({
    name: 'promotion',
    initialState,
    reducers: {
        setPromotionId: (state, action) => {
            state.promotionId = action.payload.type
        },
         setDefaultBrand: (state, action) => {
            state.defaultBrand = action.payload.type
        },
        setPromotionDataList: (state, action) => {
            state.promotionDataList = action.payload.type
        },
        setPromotionDataListById: (state, action) => {
            state.promotionDataListById = action.payload.type
        },
        setIsEditFormVisible: (state, action) => {
            state.isEditFormVisible = action.payload.type
        },
        setOnEdit: (state, action) => {
            state.onEdit = action.payload.type
        },
        setCreatePromotionDetails: (state, action) => {
            state.createPromotionDetails = action.payload.type
        },
        setEndDate: (state, action) => {
            state.endDate = action.payload.type
        },
        setStartDate: (state, action) => {
            state.startDate = action.payload.type
        },
        setFilterModel: (state, action) => {
            state.filterModel = action.payload.type
        },
        setStyleCodeType: (state, action) => {
            state.styleCodeType = action.payload.type
        },
    }
});

export const promotionActions = promotionSlice.actions;
export default promotionSlice;
